import React, { useEffect, useRef } from 'react';
import { SOCIAL_MEDIA } from '../../data/constants';
import { loadFacebookSdk } from '../../utils/facebook';
import './FacebookFeed.css';

interface FacebookFeedProps {
  width?: number;
  height?: number;
  showPosts?: number;
  hideCover?: boolean;
  hideCTA?: boolean;
  smallHeader?: boolean;
  adaptContainerWidth?: boolean;
}

const FacebookFeed: React.FC<FacebookFeedProps> = ({
  width = 340,
  height = 500,
  showPosts = 3,
  hideCover = false,
  hideCTA = false,
  smallHeader = true,
  adaptContainerWidth = true
}) => {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    loadFacebookSdk().then(() => {
      if (window.FB?.XFBML?.parse && containerRef.current) {
        window.FB.XFBML.parse(containerRef.current);
      }
    });
  }, []);

  // Extract page name from Facebook URL
  const getPageUrl = () => {
    const facebookUrl = SOCIAL_MEDIA.find(social => social.platform === 'Facebook')?.url;
    return facebookUrl || 'https://www.facebook.com/fizjofit.pabich/';
  };

  return (
    <div className="facebook-feed" ref={containerRef}>
      <div className="facebook-feed-container">
        <div className="facebook-feed-header">
          <i className="fab fa-facebook-f"></i>
          <h3>Najnowsze z Facebooka</h3>
        </div>
        
        <div className="facebook-feed-content">
          <div 
            className="fb-page" 
            data-href={getPageUrl()}
            data-tabs="timeline"
            data-width={width}
            data-height={height}
            data-small-header={smallHeader ? 'true' : 'false'}
            data-adapt-container-width={adaptContainerWidth ? 'true' : 'false'}
            data-hide-cover={hideCover ? 'true' : 'false'}
            data-show-facepile="true"
            data-hide-cta={hideCTA ? 'true' : 'false'}
          >
            <blockquote cite={getPageUrl()} className="fb-xfbml-parse-ignore">
              <a href={getPageUrl()}>
                Fizjofit - P.G Pabich
              </a>
            </blockquote>
          </div>
        </div>
        
        <div className="facebook-feed-footer">
          <a 
            href={getPageUrl()} 
            target="_blank" 
            rel="noopener noreferrer"
            className="facebook-link-button"
          >
            <i className="fab fa-facebook-f"></i>
            Odwiedź nasz Facebook
          </a>
        </div>
      </div>
    </div>
  );
};

export default FacebookFeed;
